import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Articles() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Dive into a world of luxury living with First-Class.com. Explore lifestyle articles covering fashion, wellness, and other premium topics'
          }
        />
        <title>Lifestyle Articles: Explore High-End Lifestyle Trends</title>
      </Head>
      <ArticlesList subtype="Articles" type="Lifestyle" />
    </>
  );
}

export default withLayout(Articles, true);
